import React, { useState, useEffect } from 'react'
import axios from 'axios'
import Layout from '../../layout/Layout'
import Spinner from '../../layout/Spinner'
import { api } from '../../utils/Api'
import { faPlusSquare, faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link, useHistory } from 'react-router-dom';
import EmployeeTypePicker from '../employee/EmployeeTypePicker'

const EmailsValidation = () => {
    const [loading, setLoading] = useState(true)
    const [term, setTerm] = useState('')
    const [employeeList, setEmployeeList] = useState([])

    useEffect(() => {
        search()
    }, [])

    const search = () => {
        getEmployeeListSearch()
    }

    const getEmployeeListSearch = async() => {
        setLoading(true)

        const url = api + `/employees/search/status?status=${"Hired"}&term=${term}`
        const token = localStorage.getItem('token')
        axios.defaults.headers.common = { 'Authorization': `Bearer ${token}` }

        try {
            const { data } = await axios.get(url)
            setEmployeeList(data)
            setLoading(false)
        } catch (err) {
            console.error(err.message)
            return null
        }
    }

    const RenderLoading = () => {
        return <Spinner />
    }

    const RenderTable = () => {
        return <div style={{maxWidth: '100%', marginTop: 20}}>
            <table className="table">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Role</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        employeeList.length !== 0 ?
                        employeeList.map((employee) =>{
                            return (
                                <tr key={employee._id}>
                                    <td><Link  to={'/emailvalidation/'+employee._id}>{`${employee.name} ${employee.middleName} ${employee.lastName}`}</Link></td>
                                    <td>{employee.workEmail ? employee.workEmail : 'None'}</td>
                                    <td>{employee.role ? employee.role : 'None'}</td>
                                </tr>
                            )
                        })
                        :
                        <tr><td colSpan={7} className='text-center'>No employees to display</td></tr>
                    }
                </tbody>
            </table>
        </div>
    }    

    const SearchEmployee = () => (
        <div>
            <div className="form-group row">
                <div className="col-sm-4">
                    <input
                        type='text'
                        name='term'
                        size='40'
                        className="form-control"
                        placeholder="Search..."
                        defaultValue={term}
                        onBlur={(e) => setTerm(e.target.value)}
                    />
                </div>
                <div className="col-sm-2">
                    <button onClick={search} className='btn btn-primary w-100'>
                        <FontAwesomeIcon icon={faSearch} />&nbsp;Search
                    </button>
                </div>
            </div>
        </div>
    )

    return (
        <Layout
            title='Email Employee Validation'
            description='Assign email to employee'
            className='container col-md-10'
        >
            <SearchEmployee/>
            {
                loading ? <RenderLoading/> : <RenderTable/>
            } 
        </Layout>
    )
}

export default EmailsValidation